export enum SeriesType {
  BeforeAfter = 1,
  Multi = 2
}
